<template>
    <div class="row">
        <div class="col-lg-6 offset-lg-3 d-flex flex-wrap">
            <PageHeader :title="title" :items="items" />

            <div class="card w-100">
                <div class="card-body">
                    <vue-form-generator ref="form" tag="div" :schema="studentSchema" :model="data" :options="{ validateAfterChanged: true }" />
                    <div class="d-flex justify-content-end mt-3">
                        <q-button :loading="submitLoading" @click="onChangeSubmit">Valider les changements</q-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import { debounce } from "@/helpers/functions";

    export default {
        page: {
            title: "Mon profil",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            PageHeader,
        },
        data: () => ({
            title: "Mon profil",
            items: [],
            villes: [],
            data: {},
            studentsList: [],
            selectedStudent: null,
            modalStudent: null,
            editDisabled: true,
            submitLoading: false,
            loading: false
        }),
        methods: {
            onSurveySubmited(filiere) {
                if (!filiere) return;
                const index = this.selectedStudent.filieres.findIndex(item => item.id == filiere.id);
                this.selectedStudent.filieres.splice(index, 1, filiere);
            },
            async onSearch(search) {
                const efp = localStorage.getItem("selected-efp");
                const typeEfp = localStorage.getItem("selected-efp-type");
                const students = await this.$axios.get("/students/search", { params: { efp, typeEfp, search } });
                this.studentsList = students;
            },
            onFormationClick(selectedStudent, filiere) {
                this.modalStudent = {
                    nom: selectedStudent.nom,
                    prenom: selectedStudent.prenom,
                    filiere: filiere.nom,
                    stagiaireFiliere: filiere.stagiaireFiliere,
                    date: filiere.date
                };

                this.$nextTick(() => {
                    this.$bvModal.show("quest-modal");
                });
            },
            onEFPChanged() {
                this.selectedStudent = null;
                this.studentsList = [];
            },
            async onChangeSubmit() {
                this.submitLoading = true;
                const { pass } = this.data;
                await this.$axios.put("/users/profile", {
                    pass
                });
                this.submitLoading = false;
                this.data.pass = "";
            }
        },
        mounted() {
            this.$axios.get("/users/profile").then(res => {
                this.data = res;
            });
        },
        beforeDestroy() {
            this.mitt.off("efp-changed", this.onEFPChanged);
        },
        created() {
            this.onSearch = debounce(this.onSearch, 500);
        },
        computed: {
            studentSchema() {
                return {
                    groups: [
                        {
                            styleClasses: "row",
                            fields: [
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Code",
                                    model: "code",
                                    styleClasses: "col-12 font-size-12 text-muted",
                                    disabled: true
                                },
                                {
                                    type: "input",
                                    inputType: "text",
                                    label: "Nom",
                                    model: "nom",
                                    styleClasses: "col-12 font-size-12 text-muted",
                                    disabled: true
                                },
                                {
                                    type: "b-input",
                                    inputType: "password",
                                    label: "Mot de passe",
                                    model: "pass",
                                    styleClasses: "col-12 font-size-12 text-muted",
                                    required: true
                                },
                            ]
                        }
                    ]
                };
            }
        }
    };
</script>

<style>
    #sidebar-right___title__ {
        font-size: 18px;
    }

    .custom-radio,
    .custom-checkbox {
        margin-bottom: 4px;
    }
</style>
